import React, { useContext } from "react";
import { AnnonceContext } from "../context/AnnonceProvider";

const MiniBandeauAnnonce = () => {
  const { afficherAnnonce, avantConge, modaleVue } = useContext(AnnonceContext);

  if (!afficherAnnonce || !modaleVue) return null;

  return (
    <div className="miniBandeauAnnonce" role="status" aria-live="polite">
      <span className="miniBandeauTexte">
        {avantConge ? (
          <>
            🤍 Congé maternité à partir du <strong>3 juillet</strong> — reprise
            à l'automne. Contact&nbsp;:{" "}
            <a href="tel:+33618010504">06 18 01 05 04</a>
          </>
        ) : (
          <>
            🤍 Actuellement en congé maternité — reprise à l'automne.
            Contact&nbsp;: <a href="tel:+33618010504">06 18 01 05 04</a>
          </>
        )}
      </span>
    </div>
  );
};

export default MiniBandeauAnnonce;
